import { render } from "./Conversations.vue?vue&type=template&id=4b584870&scoped=true&lang=pug"
import script from "./Conversations.vue?vue&type=script&lang=js"
export * from "./Conversations.vue?vue&type=script&lang=js"

import "./Conversations.vue?vue&type=style&index=0&id=4b584870&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b584870"]])

export default __exports__